import path from "ramda/es/path";
import compose from "ramda/es/compose";
import flatten from "ramda/es/flatten";
import hasPath from "ramda/es/hasPath";
import isEmpty from "ramda/es/isEmpty";
import length from "ramda/es/length";
import map from "ramda/es/map";
import reject from "ramda/es/reject";
import tail from "ramda/es/tail";
import times from "ramda/es/times";
import unnest from "ramda/es/unnest";
import values from "ramda/es/values";
import isNilOrEmptyString from "ramda-extension/es/isNilOrEmptyString";
import rejectNil from "ramda-extension/es/rejectNil";
import { getArrayNestedLevel, getDeepPath } from '../../utils/data';
import { fieldType, specialValidations } from '../constants';
const mapUnnestValues = compose(unnest, values, map);
const extractValues = compose(map(values), rejectNil, flatten);
const getArrayPathWithoutIndex = (formDescriptor, formData, arrayName, result = [])=>{
    const arrayRecord = formDescriptor[arrayName];
    const newResult = [
        arrayRecord.arrayDeepPath,
        ...result
    ];
    if (arrayRecord.nestedInArray) {
        return getArrayPathWithoutIndex(formDescriptor, formData, arrayRecord.nestedInArray, newResult);
    } else {
        return newResult;
    }
};
const getRawFieldNames = (formData, arrays, fieldName, indices = [], actualPath = [])=>{
    const arrayLength = length(path([
        ...actualPath,
        ...arrays[0]
    ], formData));
    if (!arrayLength) {
        return [];
    }
    return times((n)=>{
        if (arrays[1]) {
            return getRawFieldNames(formData, tail(arrays), fieldName, [
                ...indices,
                n
            ], [
                ...actualPath,
                ...arrays[0],
                n
            ]);
        } else {
            return {
                fieldName,
                indices: [
                    ...indices,
                    n
                ]
            };
        }
    }, arrayLength);
};
export const createFieldMapping = (filteredDescriptor, formDescriptor, formData)=>mapUnnestValues(({ fieldName, type, array })=>{
        if (type === fieldType.FIELD_ARRAY) {
            const arraysWithoutIndex = getArrayPathWithoutIndex(formDescriptor, formData, array);
            const rawFieldNames = getRawFieldNames(formData, arraysWithoutIndex, fieldName);
            return extractValues(rawFieldNames);
        }
        return [
            [
                fieldName,
                undefined
            ]
        ];
    }, filteredDescriptor);
export const getSectionFieldsToValidate = (formDescriptor, formData, formFieldState, section)=>{
    const fieldState = values(formFieldState);
    const sectionDescriptorWithoutArray = reject(({ type, fieldName })=>{
        if (fieldType.ARRAY === type) {
            return true;
        } else {
            const field = fieldState.find(({ fieldName: fieldStateFieldName })=>fieldStateFieldName === fieldName);
            return field?.section !== section;
        }
    }, formDescriptor);
    return createFieldMapping(sectionDescriptorWithoutArray, formDescriptor, formData);
};
export const getFieldsToValidateFromDescriptor = (formDescriptor, formData)=>{
    const formDescriptorWithoutArray = reject(({ type })=>fieldType.ARRAY === type, formDescriptor);
    return createFieldMapping(formDescriptorWithoutArray, formDescriptor, formData);
};
export const getFieldsToValidateFromFormData = (formDescriptor, formData)=>{
    const descriptorWithoutNonExistingFields = reject((fieldDescriptor)=>{
        if (fieldDescriptor.type === fieldType.ARRAY) {
            return false;
        }
        let fieldIndices = undefined;
        if (fieldDescriptor.type === fieldType.FIELD_ARRAY) {
            // check just for first occurrence in array, everything else is resolved in validations
            fieldIndices = [
                ...times(()=>0, getArrayNestedLevel(formDescriptor, fieldDescriptor.array)),
                0
            ];
        }
        return !hasPath(getDeepPath(formDescriptor, fieldDescriptor, fieldIndices), formData);
    }, formDescriptor);
    return getFieldsToValidateFromDescriptor(descriptorWithoutNonExistingFields, formData);
};
export const isEmptyResult = compose(isEmpty, reject(isEmpty), values);
export const isFilled = ({ fieldValue })=>!isNilOrEmptyString(fieldValue);
export const rejectSpecialValidations = (validations)=>validations.filter(({ type })=>!Object.values(specialValidations).includes(type));
export const hasVisibileValidation = (validations)=>validations.some(({ type })=>type === specialValidations.VISIBLE);
export const hasAccessibleValidation = (validations)=>validations.some(({ type })=>type === specialValidations.ACCESSIBLE);
export const isSpecialValidation = (type)=>Object.values(specialValidations).includes(type);
